import React, { useState, useEffect } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { getReservation } from "../Services";

function Ticket(props) {
  const [reservation, setReservation] = useState(null);
  const reservationId =
    props.match && props.match.params ? props.match.params.rid : null;

  useEffect(() => {
    // Only run the effect if we have a reservation ID
    if (reservationId) {
      getReservation(reservationId)
        .then((res) => {
          setReservation(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [reservationId]); // The effect will re-run only when the reservationId changes

  return (
    <Row
      style={{
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        margin: 0,
      }}
    >
      {reservation && (
        <Row style={{ width: "100%" }}>
          <Col>
            <Card style={{ padding: 10, marginTop: 10 }}>
              <Row>
                <Col>
                  Reference No :{" "}
                  {reservation.payment &&
                    reservation.payment.application_number}
                </Col>
              </Row>
              <hr />
              <Row>
                <Col>
                  <Row>
                    <Col>
                      From <b>{reservation.from}</b> to <b>{reservation.to}</b>
                    </Col>
                    <Col align="right">
                      {reservation.date} {reservation.time}
                    </Col>
                  </Row>
                  <Row>
                    <Col>Transport Mode : {reservation.train}</Col>
                  </Row>
                  <Row>
                    <Col>Class : {reservation.trainClass}</Col>
                  </Row>
                  <Row>
                    <Col>Quantity : {reservation.qty}</Col>
                  </Row>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col>
                  Payment Method : <b>{reservation.paymentMethod}</b>
                </Col>
              </Row>
              <Row>
                <br />
                <Col>Amount : {reservation.amount.toFixed(2)}</Col>
                <Col align="right">
                  <b>Total :</b> {reservation.total.toFixed(2)}
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      )}
    </Row>
  );
}

export default Ticket;
